import { Stage } from "konva/lib/Core";
import { Util } from "konva/lib/Util";
import { RGB } from "konva/types/types";
import { IPosition } from "./shapes";

export const isSafari = (): boolean => /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

export const isFirefox = (): boolean => navigator.userAgent.toLowerCase().indexOf("firefox") > -1;

export const px = (num: number): string => `${num}px`;

const multiplyRgb = (rgb: RGB, value: number): RGB => {
  const mul = (n: number) => Math.min(Math.max(Math.round(n * value), 0), 255);
  return { r: mul(rgb.r), g: mul(rgb.g), b: mul(rgb.b) };
};

export const darken = (color: string, value: number): string => {
  const source = Util.getRGB(color);
  const lum = 1 - Math.abs(value);
  const rgb = multiplyRgb(source, lum);

  return "#" + rgb.r.toString(16) + rgb.g.toString(16) + rgb.b.toString(16);
};

export const rgbToHsp = (rgb: RGB): number => {
  // http://alienryderflex.com/hsp.html
  return Math.sqrt(0.299 * (rgb.r * rgb.r) + 0.587 * (rgb.g * rgb.g) + 0.114 * (rgb.b * rgb.b));
};

// https://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb
export const rgbToHex = (rgb: string): string => {
  const componentToHex = (c: number): string => {
    const hex = c.toString(16);
    return hex.length == 1 ? "0" + hex : hex;
  };

  const [r, g, b] = rgb.replace("rgb", "").replace(/[()]/g, "").split(",");

  return ("#" + componentToHex(+r) + componentToHex(+g) + componentToHex(+b)).toUpperCase();
};

export const clipSquare = (ctx: CanvasRenderingContext2D, options: { x: number; y: number; width: number; height: number; radius: number }): void => {
  const { x, y, width, height, radius } = options;
  ctx.beginPath();
  ctx.moveTo(x + radius, y);
  ctx.lineTo(x + width - radius, y);
  ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
  ctx.lineTo(x + width, y + height - radius);
  ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
  ctx.lineTo(x + radius, y + height);
  ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
  ctx.lineTo(x, y + radius);
  ctx.quadraticCurveTo(x, y, x + radius, y);
  ctx.closePath();
};

export const nucleoOutlineIconText = (iconCss: string): string => {
  const tmp = document.createElement("span");
  tmp.className = `nc-icon-outline ${iconCss}`;
  document.body.appendChild(tmp);

  let text = window.getComputedStyle(tmp, ":before").getPropertyValue("content");
  // in some browsers it is encoded in quotes
  if (text.length === 3) {
    text = text.slice(1, -1);
  }
  tmp.remove();

  return text;
};

export const relativePointerPosition = (stage: Stage): IPosition => relativePosition(stage, stage.getPointerPosition());

export const relativePosition = (stage: Stage, pos: IPosition): IPosition => stage.getAbsoluteTransform().copy().invert().point(pos);

export const getRandomColor = (): string =>
  `#${Math.floor(Math.random() * 16777215)
    .toString(16)
    .padStart(6, "0")}`;
